export function isNotFound(res) {
  return res.status === 404
}

export function isNotAuthorize(res) {
  return res.status === 401
}

export function isOk(res) {
  return res.status === 200
}
